import { render, staticRenderFns } from "./ProductsGridItem.vue?vue&type=template&id=9eff5c26&"
import script from "./ProductsGridItem.vue?vue&type=script&lang=js&"
export * from "./ProductsGridItem.vue?vue&type=script&lang=js&"
import style0 from "./ProductsGridItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports